/* eslint-disable react-hooks/exhaustive-deps */

import React, { useCallback, useState, useEffect, useMemo } from 'react';
import searchIcon from '../assets/search-white.svg';
import {
  ReactFlow,
  Controls,
  Background,
  ReactFlowProvider,
  useNodesState,
  useEdgesState,
  addEdge,
} from '@xyflow/react';

import '@xyflow/react/dist/style.css';
import ChevronDown from './ChevronDown';
import ChevronUp from './ChevronUp';
// import { fetchTopicData } from '../services/api';
// import { saveHierarchyToFirestore } from '../services/firestore';
import SideBar from './NavBar';
import { signInWithGoogle } from "../services/firebase";
// import UserMenu from "./userMenu";
import { useUserContext } from "../context/UserContext";
import SignInModal from './SigninModal';
import {auth} from '../services/firebase'
import ImageModal from './ImageModal';
import TableOfContents from './TableofContents';
import useSuggestionHandler from '../hooks/useSuggestionHandler';
import useNodeBuilder from '../hooks/useNodeBuilder';
import useEventHandlers from '../hooks/useEventHandlers';
import useNavbarHandler from '../hooks/useNavBarHandler';
import { getStyles } from './styles'; // Import styles
import { loadingMessages } from './LoadingButton';
import DiveDeeperSection from './DiveDeeperSection';
import NotesButton from './NotesButton';
import NotesModal from './NotesModal';
import InstallPrompt from './InstallPrompt';
import ExportButton from './ExportButton';

const searchSuggestionsArray = [
  { text: 'Space Exploration', icon: '🚀' },
  { text: 'Is Climate Change real', icon: '🌍' },
  { text: 'Microeconomics', icon: '🌐' },
  { text: 'The current AI Hype', icon: '🤖' },
];

const SearchSuggestions = React.memo(({ onSuggestionClick, isMobile }) => {
  return (
    <div
      style={{
        width: isMobile ? '85%' : '550px', // Match the search box width
        display: 'flex',
        flexWrap: 'wrap', // Allow stacking
        alignItems: 'flex-start', // Align items at the top
        gap: '10px', // Add gap between suggestions
        zIndex: 1000,
        marginTop: '20px', // Space below the search box
      }}
    >
      {searchSuggestionsArray.map((suggestion, index) => (
        <button
          key={index}
          onClick={() => onSuggestionClick(suggestion.text)}
          style={{
            flex: '1 1 calc(50% - 10px)', // Each suggestion takes 50% width minus gap
            background: 'rgba(0, 0, 0, 0.3)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '10px',
            padding: '10px 15px',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '14px',
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 200,
            textAlign: 'left', // Align text to the left
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: '10px', // Add spacing between icon and text
            transition: 'all 0.2s ease',
          }}
        >
          {/* Icon for the suggestion */}
          <span
            style={{
              display: 'inline-block',
              fontSize: '18px', // Adjust font size for emoji or icon
            }}
          >
            {suggestion.icon}
          </span>
          {/* Text for the suggestion */}
          {suggestion.text}
        </button>
      ))}
    </div>
  );
});

const MAX_COLLAPSED_LENGTH = 300;

const LoadingSpinner = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prevIndex) => (prevIndex + 1) % loadingMessages.length);
    }, 5000); // change message every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        padding: '20px 30px',
        background: 'rgba(30, 30, 30, 0.7)',
        backdropFilter: 'blur(30px)',
        borderRadius: '10px',
        color: '#fff',
        fontSize: '14px',
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 200,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
        textAlign: 'center',
        zIndex: 1000,
      }}
    >
      {loadingMessages[messageIndex]}
    </div>
  );
};

const ErrorMessage = React.memo(({ message }) => (
  <div
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      padding: '20px',
      background: 'rgba(255,0,0,0.1)',
      border: '1px solid #ff0000',
      borderRadius: '8px',
      color: '#ff0000',
      zIndex: 1000,
    }}
  >
    {message}
  </div>
));

const TopicFlow = () => {
  // const [user, setUser] = useState(null);
  // const [userId, setUserId] = useState(null);
  const { user } = useUserContext();
  const userId = user?.uid;
  // console.log('Initiated user and user id: ', user, userId)

  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [topic, setTopic] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const [expandedNodes, setExpandedNodes] = useState({});
  const [expandedContent, setExpandedContent] = useState({});
  const [loadingNodes, setLoadingNodes] = useState(new Set());
  const [topicData, setTopicData] = useState(null);
  const [nodesWithChildren, setNodesWithChildren] = useState(new Set());
  const [sessionId, setSessionId] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isImgModalOpen, setIsImgModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  // const [images, setImages] = useState([]);
  const [modalImages, setModalImages] = useState([]);

  // Function to handle React Flow initialization
  const onInit = (instance) => {
    setReactFlowInstance(instance);
  };

  const [reactFlowInstance, setReactFlowInstance] = useState(null);

  const [isMobile, setIsMobile] = useState(false);

  const [showSearchSuggestions, setShowSearchSuggestions] = useState(true);
  const [isSearchTriggered, setIsSearchTriggered] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);

  const [installPromptEvent, setInstallPromptEvent] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault(); // Prevent automatic prompt
      setInstallPromptEvent(event); // Save the event for later use
      setShowInstallPrompt(true); // Show the notification
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const [notesKey, setNotesKey] = useState(0); // Add this to force Notes component update
  const handleModalOpen = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setIsModalOpen(true);
  };

  const handleNotesUpdate = useCallback(() => {
    // Force Notes component to re-render when notes are updated
    setNotesKey(prev => prev + 1);
  }, []);

  useEffect(() => {
    window.addEventListener('notesUpdated', handleNotesUpdate);
    return () => {
      window.removeEventListener('notesUpdated', handleNotesUpdate);
    };
  }, [handleNotesUpdate]);
  
  // const styles = useStyles(isMobile, isSearchTriggered, isCollapsed);

  const { getAllDescendants, formatContent } = useUtilityFunctions(nodes);

  const { createNodesFromData, createEdgesFromData, createHierarchicalLayout } = useNodeBuilder(
    createNodeLabel,
    isMobile
  );  

  const [childrenExpanded, setChildrenExpanded] = useState({});

  const [isSignInModalOpen, setSignInModalOpen] = useState(false);
  const [authError, setAuthError] = useState(null);

  const openSignInModal = () => setSignInModalOpen(true);
  const closeSignInModal = () => setSignInModalOpen(false);

  const handleSignOut = async () => {
    try {
      await auth.signOut(); // Sign out from Firebase
      // console.log("User successfully signed out from Firebase.");
    } catch (error) {
      console.error("Error during sign-out:", error);
    }
  };
  
  const handleCollapseChange = (collapsed) => {
    setIsCollapsed(collapsed); // Update state when Sidebar collapses/expands
  };

  // const handleCloseModal = () => {
    // setIsModalOpen(false);
  // };

  const handleCloseImgModal = () => {
    setIsImgModalOpen(false);
  };
  const { handleSearchClick, handleDiveDeeper } = useEventHandlers({
    user,
    openSignInModal,
    setNodes,
    setEdges,
    setTopic,
    setExpandedNodes,
    setExpandedContent,
    setIsLoading,
    setError,
    setShowSearchSuggestions,
    setTopicData,
    setSessionId,
    nodes,
    sessionId,
    userId,
    createNodesFromData,
    createEdgesFromData,
    createHierarchicalLayout,
    setLoadingNodes,
    setNodesWithChildren,
    setChildrenExpanded,
    setIsSearchTriggered,
    isSearchTriggered,
  });
  
  useEffect(() => {
    // console.log("isSearchTriggered changed:", isSearchTriggered, userId);
  }, [isSearchTriggered, userId]);
  
  const { handleSuggestionClick } = useSuggestionHandler(
    user,
    openSignInModal,
    setTopic,
    setIsLoading,
    setError,
    setShowSearchSuggestions,
    setIsSearchTriggered,
    setTopicData,
    setSessionId,
    createNodesFromData,
    createEdgesFromData,
    sessionId,
    setNodes,
    setEdges,
  );

  const { handleNavbarClick } = useNavbarHandler({
    setIsLoading,
    setError,
    createNodesFromData,
    createEdgesFromData,
    setNodesWithChildren,
    setNodes,
    setEdges,
    setExpandedNodes,
    setExpandedContent,
    user,
    setIsSearchTriggered,
    setShowSearchSuggestions,
    setTopicData
  });

  useEffect(() => {
    // console.log("isSearchTriggered changed:", isSearchTriggered);
  }, [isSearchTriggered]);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const styles = useMemo(() => getStyles(isMobile, isSearchTriggered, isCollapsed), [
    isMobile,
    isSearchTriggered,
    isCollapsed,
  ]);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearchClick(topic);
    }
  };  

  useEffect(() => {
    // console.log('expandedContent:', expandedContent);
  }, [expandedContent]);    

  const [showSearchInput] = useState(false);
  const [searchQuery] = useState('');

  // Function to focus on a node with animation
  const focusOnNode = useCallback((nodeId) => {
    if (!reactFlowInstance || !nodeId) return;
    
    // Find the node by ID
    const node = nodes.find((n) => n.id === nodeId);
    if (!node) return;
    
    // Add a temporary highlight effect to the node
    setNodes((nds) =>
      nds.map((n) => ({
        ...n,
        style: {
          ...n.style,
          // Only add styling to the target node
          ...(n.id === nodeId ? {
            boxShadow: '0 0 20px #7CACF8',
            border: '1px solid #7CACF8',
            zIndex: 1000,
          } : {})
        },
      }))
    );

    // Use setTimeout to ensure the node highlight appears before scrolling
    setTimeout(() => {
      // Get the current viewport
      // const { zoom } = reactFlowInstance.getViewport();
      
      // Zoom to the node
      reactFlowInstance.fitBounds(
        {
          x: node.position.x - 0,
          y: node.position.y + 50,
          width: 400,
          height: 200
        },
        {
          padding: 0.2,
          duration: 800,
          minZoom: 0.5,
          maxZoom: 1.5
        }
      );
      
      // Remove highlight after animation completes
      setTimeout(() => {
        setNodes((nds) =>
          nds.map((n) => ({
            ...n,
            style: n.id === nodeId ? {
              ...n.style,
              boxShadow: undefined,
              border: undefined,
              zIndex: 0
            } : n.style
          }))
        );
      }, 2500);
    }, 50);
  }, [reactFlowInstance, nodes, setNodes]);
  
  function createNodeLabel(
    header,
    content,
    urlSources,
    nodeId,
    hasChildNodes = false,
    type,
    images = []
  ) {
    const isContentExpanded = expandedContent[nodeId];
    // console.log('is content expanded: ', isContentExpanded, expandedContent[nodeId])
    const isLoadingNode = loadingNodes.has(nodeId);
    const nodeHasChildrenLoaded = nodesWithChildren.has(nodeId);
    // console.log('nodes with children: ', nodeHasChildrenLoaded, nodesWithChildren, nodeId)

    // console.log('current header: ', header, ' has children: ', hasChildNodes, nodeHasChildrenLoaded, ' is expanded: ', isContentExpanded)
    // Toggle child node expansion
    const handleExpandToggle = (e) => {
      e.stopPropagation();
      setExpandedNodes((prev) => ({
        ...prev,
        [nodeId]: !prev[nodeId],
      }));
    };
  
    // Toggle content expansion
    const handleContentToggle = (e) => {
      e.stopPropagation();
      // console.log('handle content toggle expanded content before: ', expandedContent)
      setExpandedContent((prev) => ({
        ...prev,
        [nodeId]: !prev[nodeId],
      }));
      // console.log('handle content toggle expanded content after: ', expandedContent)
    };

    // New function to handle opening the image modal
    const handleShowImages = (e) => {
      e.stopPropagation();
      if (images && images.length > 0) {
        setModalTitle(header);
        // We're using the existing ImageModal component
        setModalImages(images);
        setIsImgModalOpen(true);
      }
    };
  
    const shouldTruncate = content && content.length > MAX_COLLAPSED_LENGTH;
    const displayContent = shouldTruncate
      ? `${content.substring(0, MAX_COLLAPSED_LENGTH)}...`
      : content;

    return (
      <div
        style={{
          padding: isMobile ? '8px' : '10px',
          textAlign: 'left',
          maxWidth: isMobile ? '250px' : '300px',
          position: 'relative',
        }}
      >
        {/* Header and Chevron for Expand/Collapse */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: isMobile ? '14px' : '16px',
            transition: 'color 0.2s ease',
            cursor: 'pointer',
          }}
          onClick={handleContentToggle}
        >
          <strong
            style={{
              fontSize: isMobile ? '14px' : '16px',
              color: '#ffffff',
              fontFamily: "'Poppins', sans-serif",
              transition: 'color 0.2s ease',
            }}
          >
            {header}
          </strong>
          <div onClick={handleExpandToggle} style={{ cursor: 'pointer' }}>
            {isContentExpanded ? <ChevronUp /> : <ChevronDown />}
          </div>
        </div>

        <div
          style={{
            marginTop: '20px',
            fontSize: isMobile ? '11px' : '13px',
            lineHeight: '1.6',
            color: '#fff',
            fontFamily: "'Poppins', sans-serif",
          }}
        ></div>
        <div dangerouslySetInnerHTML={{ __html: formatContent(displayContent) }} />
        {shouldTruncate && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleModalOpen(header, formatContent(content));
            }}
            style={{
              background: 'none',
              border: 'none',
              color: '#7CACF8',
              cursor: 'pointer',
              // padding: '4px 8px',
              marginTop: '8px',
              fontSize: '12px',
              fontFamily: "'Poppins', sans-serif",
              fontWeight: '400',
            }}
          >
            Continue Reading...
          </button>
        )}
        
        <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          
          {type === 'subtopic' && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleContentToggle(e); // Toggle content expansion
              }}
              style={{
                background: 'none',
                border: 'none',
                color: '#cccccc',
                cursor: 'pointer',
                padding: '4px 8px',
                marginTop: '8px',
                fontSize: '12px',
                fontFamily: "'Poppins', sans-serif",
                fontWeight: '200',
                borderTop: '1px solid #333',
                paddingTop: '12px',
                textAlign: 'left', 
              }}
            >
              {isContentExpanded ? '🔗 Hide Suggested Reads' : '🔗 Show Suggested Reads'}
            </button>
          )}
          
          {/* Show Images button - always visible */}
          {images && images.length > 0 && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleShowImages(e);
              }}
              style={{
                background: 'none',
                border: 'none',
                color: '#cccccc',
                cursor: 'pointer',
                padding: '4px 8px',
                marginTop: '-10px',
                fontSize: '12px',
                fontFamily: "'Poppins', sans-serif",
                fontWeight: '200',
                borderTop: '0px solid #333',
                paddingTop: '12px',
                textAlign: 'left', 
              }}
            >
              🖼️ Images
            </button>
          )}
          
        </div>
  
        {/* Content - Only show if expanded */}
        {isContentExpanded && (
          <div
            style={{
              marginTop: '10px',
              fontSize: isMobile ? '11px' : '13px',
              lineHeight: '1.6',
              color: '#fff',
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            {/* URLs section */}
            {urlSources && urlSources.length > 0 && (
              <div
                style={{
                  marginTop: isMobile ? '6px' : '10px',
                  fontSize: isMobile ? '10px' : '12px',
                  // borderTop: '1px solid #cccccc',
                  paddingTop: '8px',
                }}
              >
                <ul
                  style={{
                    margin: '4px 0 0 0',
                    padding: '0 0 0 16px',
                    fontSize: '11px',
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {urlSources.map((source, index) => (
                    <li key={index} style={{ marginBottom: '4px', position: 'relative' }}>
                      <a
                        href={source.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: '#7CACF8',
                          textDecoration: 'none',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        onClick={(e) => e.stopPropagation()}
                        onMouseEnter={(e) => {
                          e.currentTarget.querySelector('.tooltip').style.opacity = 1;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.querySelector('.tooltip').style.opacity = 0;
                        }}
                      >
                        <div
                          className="tooltip"
                          style={{
                            position: 'absolute',
                            background: '#ccc',
                            color: '#141414',
                            padding: '8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            width: '200px',
                            opacity: 0,
                            transition: 'opacity 0.3s',
                            pointerEvents: 'none',
                            zIndex: 1,
                            left: '0%',
                            bottom: '100%',
                            marginLeft: '8px',
                          }}
                        >
                          {source.snippet}
                        </div>
                        {source.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
  
        {/* Dive Deeper, Show/Hide Children button, Custom search*/}
        <DiveDeeperSection
          isLoadingNode={isLoadingNode}
          type={type}
          nodeId={nodeId}
          header={header}
          nodeHasChildrenLoaded={nodeHasChildrenLoaded}
          childrenExpanded={childrenExpanded}
          setChildrenExpanded={setChildrenExpanded}
          getAllDescendants={getAllDescendants}
          setNodes={setNodes}
          handleDiveDeeper={handleDiveDeeper}
          isMobile={isMobile}
        />
      </div>
    );
  }

  const handleInputChange = useCallback((event) => {
    // console.log('handle input change event', handleInputChange)
    setTopic(event.target.value);
  }, []);

  useEffect(() => {
    if (!topicData) return;

    setNodes((prevNodes) =>
      prevNodes.map((node) => {
        const hasChildNodes = nodes.some((n) => n.parentNode === node.id);
        // console.log('passed images and urls to input change: ', node.data.images, node.data.urlSources)
        return {
          ...node,
          data: {
            ...node.data,
            label: createNodeLabel(
              node.data.originalHeader,
              node.data.originalContent,
              node.data.urlSources,
              node.id,
              hasChildNodes,
              node.data.type,
              node.data.images,
            ),
          },
        };
      })
    );
  }, [expandedContent, expandedNodes, topicData, loadingNodes, childrenExpanded, searchQuery, showSearchInput]);

  const onNodeClick = useCallback(
    (event, node) => {
      if (
        event.target.tagName === 'BUTTON' ||
        event.target.tagName === 'A' ||
        event.target.closest('button') ||
        event.target.closest('a')
      ) {
        return;
      }
    },
    [expandedNodes, getAllDescendants, setNodes]
  );

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges]
  );


  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
      // console.log('Sign-in successful!');
      // setUser(signedInUser);
      closeSignInModal(); // Close the modal on successful sign-in
    } catch (error) {
      setAuthError('Failed to sign in. Please try again.');
      console.error('Google Sign-In Error:', error);
    }
  };  

  return (
    <ReactFlowProvider>
      <div
        style={{
          width: '100vw',
          height: '100vh',
          background: '#000',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* User Menu at the top-right */}
        {/* <div style={styles.userMenuContainer}> */}
          {/* {user && <UserMenu user={user} onSignOut={handleSignOut} />} */}
        {/* </div> */}
        
        <SideBar sessionId={sessionId} onCollapseChange={handleCollapseChange} user={user} onSignOut={handleSignOut} userId={userId} handleNavbarClick={(topicContent) => handleNavbarClick(topicContent, user)} /> {/* Add SideBar */}
        {isLoading && <LoadingSpinner />}
        {error && <ErrorMessage message={error} />}

        <div style={styles.topBar}>
        {!isSearchTriggered && (
          <>
            <div style={styles.tagline}>
              Endless canvas for endless curiosity
            </div>
            <div style={styles.searchContainer}>
              <div style={styles.searchInputContainer}>
                <input
                  type="text"
                  placeholder="Tell me everything about..."
                  value={topic}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  style={styles.input}
                  disabled={isSearchTriggered}
                />
                {!isSearchTriggered && (
                  <button style={styles.iconButton} onClick={() => handleSearchClick(topic)}>
                    <img src={searchIcon} alt="Search" style={styles.icon} />
                  </button>
                )}
              </div>
            </div>
            {showSearchSuggestions && (
              <SearchSuggestions
                onSuggestionClick={handleSuggestionClick}
                isMobile={isMobile}
              />
            )}
          </>
        )}
        </div>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          onConnect={onConnect}
          onNodeClick={onNodeClick}
          onInit={onInit} // Set the instance on initialization
          fitView
          fitViewOptions={{
            padding: isMobile ? 0.1 : 0.2,
            maxZoom: isMobile ? 1.2 : 1.5,
          }}
          minZoom={0.1}
          maxZoom={1.5}
          zoomOnScroll={!isMobile}
          panOnScroll={isMobile}
          zoomOnPinch={true}
          nodesDraggable={true}
          nodesConnectable={false}
        >
          <Background variant="dots" gap={16} size={2} color="#4D4D4D" />
          <Controls showInteractive={true} />
        </ReactFlow>

        <TableOfContents
          nodes={nodes}
          onNodeClick={focusOnNode} // Use our focusOnNode function
          isMobile={isMobile}
          isSearchTriggered={isSearchTriggered}
        />

        {/* <TableOfContents
          nodes={nodes}
          onNodeClick={(nodeId) => {
            const node = nodes.find((n) => n.id === nodeId);
            if (node) {
              // Create a custom fit view action to focus on the selected node
              const reactFlowInstance = document.querySelector('.react-flow').reactFlowInstance;
              if (reactFlowInstance) {
                // Set a timeout to ensure the flow instance is ready
                setTimeout(() => {
                  // Calculate center position for the node with some padding
                  const x = node.position.x;
                  const y = node.position.y;
                  
                  // Zoom to the node with animation
                  reactFlowInstance.setCenter(x, y, { duration: 800, zoom: 1.2 });
                  
                  // Highlight the node temporarily
                  setNodes((nds) =>
                    nds.map((n) => ({
                      ...n,
                      style: {
                        ...n.style,
                        boxShadow: n.id === nodeId ? '0 0 20px #7CACF8' : undefined,
                        zIndex: n.id === nodeId ? 1000 : n.style?.zIndex || 0,
                      },
                    }))
                  );
                  
                  // Remove highlight after animation
                  setTimeout(() => {
                    setNodes((nds) =>
                      nds.map((n) => ({
                        ...n,
                        style: {
                          ...n.style,
                          boxShadow: undefined,
                          zIndex: n.style?.zIndex === 1000 ? 0 : n.style?.zIndex || 0,
                        },
                      }))
                    );
                  }, 2000);
                }, 50);
              }
            }
          }}
          isMobile={isMobile}
        /> */}

        <style>
          {`
            @media (max-width: 768px) {
              html, body {
                overflow: hidden;
                position: fixed;
                width: 100%;
                height: 100%;
                -webkit-overflow-scrolling: touch;
              }
              .react-flow__controls {
                transform: scale(0.8);
                transform-origin: bottom right;
              }
            }
          `}
        </style>

        <style>
          {`
            @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');
            .react-flow__node {
              transition: opacity 0.3s ease;
              opacity: 1;
              font-family: 'Poppins', sans-serif !important;
            }

            @keyframes gradientBorder {
              0% {
                background-position: 0% 50%;
              }
              100% {
                background-position: 100% 50%;
              }
            }
              
            .react-flow__node:hover {
              opacity: 1;
              border: 2px solid #7CACF8;
              
            }
            .react-flow__handle {
              background: #000;
              width: 8px;
              height: 8px;
            }
            .react-flow__edge {
              transition: stroke 0.3s ease;
            }
            .react-flow__edge:hover {
              stroke: #141414 !important;
            }
            input {
              font-family: 'Poppins', sans-serif !important;
              font-weight: 400;
            }
            button {
              font-family: 'Poppins', sans-serif !important;
              font-weight: 500;
            }
            div::-webkit-scrollbar {
              width: 6px;
            }
            div::-webkit-scrollbar-track {
              background: #888888;
            }
            div::-webkit-scrollbar-thumb {
              background: #141414;
              border-radius: 3px;
            }
            div::-webkit-scrollbar-thumb:hover {
              background: #555;
            }
          `}
        </style>
      </div>
      <ImageModal 
        isOpen={isImgModalOpen} 
        onClose={handleCloseImgModal} 
        images={modalImages} 
        title={modalTitle}
      />
      <NotesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        content={modalContent}
        title={modalTitle}
        isMobile={isMobile}
      />
      <NotesButton
          key={notesKey}
          isMobile={isMobile}
      />
      <ExportButton 
        nodes={nodes}
        sessionId={sessionId}
      />
      <SignInModal
        isOpen={isSignInModalOpen}
        onClose={closeSignInModal}
        onSendLink={handleGoogleSignIn}
        authError={authError}
      />
      {showInstallPrompt && (
        <InstallPrompt
          promptEvent={installPromptEvent}
          onDismiss={() => setShowInstallPrompt(false)}
        />
      )}
    </ReactFlowProvider>
  );
};

export default TopicFlow;

// Memoized Utility Functions
function useUtilityFunctions(nodes) {
  const getAllDescendants = useCallback(
    (nodeId) => {
      const descendants = [];
      const findDescendants = (currentId) => {
        const children = nodes.filter((n) => n.parentNode === currentId);
        children.forEach((child) => {
          descendants.push(child.id);
          findDescendants(child.id);
        });
      };
      findDescendants(nodeId);
      return descendants;
    },
    [nodes]
  );

  const formatContent = useCallback((content) => {
    if (!content) return '';
    return content
      .replace(/\n/g, '<br/>')
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  }, []);

  return { getAllDescendants, formatContent };
}